import { createRoot } from 'react-dom/client';
import React from 'react';
import { ToastApp } from './ToastApp';
var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var PORTAL_ID = 'flora-toast-portal';

class ToasterBuilder {
  constructor() {
    this.notify = void 0;
    this.closeAll = void 0;
    this.portal = void 0;

    /* istanbul ignore else */
    if (!isBrowser) {
      return;
    }

    this.portal = this.getPortal();

    if (this.portal !== null) {
      var root = createRoot(this.portal);
      root.render( /*#__PURE__*/React.createElement(ToastApp, {
        bind: _ref => {
          var {
            notify,
            closeAll
          } = _ref;
          this.notify = notify;
          this.closeAll = closeAll;
        }
      }));
    }
  }

  getPortal() {
    var portalElement = document.querySelector("#" + PORTAL_ID);
    /* istanbul ignore else */

    if (!portalElement) {
      var newPortal = document.createElement('div');
      newPortal.setAttribute('id', PORTAL_ID);
      newPortal.classList.add('Toaster');
      document.body.appendChild(newPortal);
      portalElement = newPortal;
    }

    return portalElement;
  }

}
/**
 * @function
 * @name Toaster
 * @description Toaster function
 * @example
 * Toaster.notify()
 * @tutorial https://flora.gb.tech/docs/components/core/toast
 */


export var Toaster = new ToasterBuilder();
//# sourceMappingURL=Toaster.js.map